











































































































































































import DraggableDataTable from '@/components/ApplicationProcessing/DraggableDataTable.vue';
import CreatePretension from '@/components/Pretensions/CreatePretension.vue';
import { TableData } from '@/types/DraggableDataTableTypes';
import DateFilter from '@/components/common/DateFilter.vue';
import DateRange from '@/components/common/DateRange.vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { DataPagination } from 'vuetify';
import PretensionController from '@/controllers/Pretension';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import { Pretension, PretensionStatus, PretensionType } from '@/types/Pretension';
import { DraftListRow } from '@/controllers/types';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';

import _ from 'lodash';

import {
  like, and, or,
} from '@/classes/pimcore-filtering/Filters';
import UserMixin from '@/mixins/UserMixin';
import { humanizePretensionStatus } from '@/utils/pretensionsReportDisplay';
import { PretensionPrefill, pretensionPrefillFromQuery, queryWithoutPrefill } from '@/utils/sheetPretensions';

@Component({
  components: {
    DraggableDataTable,
    CreatePretension,
    DateFilter,
    DateRange,
  },
})
export default class Pretensions extends Mixins(EntityHelperMixin, UserMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'Pretensions',
  }) readonly localStoragePrefix!: string;

  headers = [
    {
      text: 'ID',
      value: 'id',
    },
    {
      text: 'Номер документа',
      value: 'sequence',
    },
    {
      text: 'Тип',
      value: 'typeName',
    },
    {
      text: 'Дата создания',
      value: 'created_at',
    },
    {
      text: 'Дата с',
      value: 'date_from',
    },
    {
      text: 'Дата по',
      value: 'date_to',
    },
    {
      text: 'Поставщик',
      value: 'supplier_legal_name',
    },
    {
      text: 'Платформа',
      value: 'platform_name',
    },
    {
      text: 'Сумма',
      value: 'total_without_tax',
    },
  ]

  get defaultPagination(): DataPagination {
    return _.cloneDeep({
      page: 1,
      pageStart: 0,
      itemsPerPage: 10,
      pageStop: 0,
      pageCount: 0,
      itemsLength: 0,
    });
  }

  tables: Array<TableData> = [
    {
      status: PretensionStatus.CONTROL_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.SIGNER_SIGNING_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.SUPPLIER_SIGNING_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.ACCOUNTING_APPROVE_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.PAYMENT_DONE,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.PROBLEM,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.RECALLED,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
  ];

  loadingPage = false;

  // Фоновое автообновление списка (каждую минуту), чтобы претензии сами переезжали
  // в блок нового статуса без ручного refresh (async-лаг бэкенда/действия других ролей).
  private pollingTimer: number | null = null;

  private isSilentReloading = false;

  private static readonly POLLING_INTERVAL_MS = 60000;

  dates: Array<any> = [];

  defaultDates: Array<any> = [];

  platformsList: Array<any> = [];

  /** Выбранные платформы; в API уходят одной строкой через запятую (см. loadPretensions). */
  selectedPlatforms: Array<string> = [];

  suppliersList: Array<any> = [];

  selectedSuppliers: Array<any> = [];

  pretensionTypesList: Array<{ name: string; value: PretensionType }> = [
    {
      name: 'Штраф',
      value: 'fine',
    },
    {
      name: 'Ущерб',
      value: 'damage',
    },
  ];

  selectedType = this.getFromStorage('type');

  drafts: DraftListRow[] = [];

  draftsLoading = false;

  // Колонки черновиков = колонки статусов + «Автор»: HR должен видеть владельца черновика
  // (свой/коллеги) в списке. Колонку не добавляем в общий headers, чтобы не плодить пустой
  // столбец у статусных таблиц, где автора нет.
  get draftHeaders(): Array<{ text: string; value: string }> {
    return [...this.displayedHeaders, { text: 'Автор', value: 'authorDisplay' }];
  }

  // Черновики в той же TableData-обёртке, что и статусы: общий компонент принимает table-data,
  // а не сырой массив. disableDraggable=true → ветка без vuedraggable. status='draft' — маркер,
  // но клик ветвится по status самой строки (см. clickRow).
  get draftsTableData(): TableData {
    return {
      status: PretensionStatus.DRAFT,
      items: this.drafts,
      loading: this.draftsLoading,
      disableDraggable: true,
      pagination: { ...this.defaultPagination, itemsLength: this.drafts.length },
    };
  }

  async loadDrafts(): Promise<void> {
    if (!this.isHR) return;
    // Вариант B: платформы из фильтра, иначе — все платформы HR. ОДИН запрос с platformIds[]
    // → PHP WHERE platform_id IN (:ids) AND status='draft' (scope = платформы HR, без over-exposure).
    const platformIds = this.selectedPlatforms.length
      ? this.selectedPlatforms.map((id) => String(id))
      : this.userPlatformIds.map((id) => String(id));
    if (platformIds.length === 0) {
      this.drafts = [];
      return;
    }
    this.draftsLoading = true;
    const resp = await PretensionController.listDrafts({ platformIds });
    const [err, payload] = resp.result;
    // Ждём {data:[...], total}. Иначе (ошибка / неожиданный ответ) — сбой, а не «пусто».
    if (err || !payload || !Array.isArray(payload.data)) {
      this.$bus.$emit('notification', `Не удалось загрузить черновики - ${err || 'неожиданный ответ сервера'}`, 'error');
      this.drafts = [];
    } else {
      // PHP сортирует по updated_at DESC через весь IN-список. typeName деривим на фронте
      // ($t(type)), как reloadTable для строк статусов — иначе колонка «Тип» (typeName) пуста.
      // status форсим в 'draft': список — всегда черновики, это делает clickRow устойчивым к
      // отсутствию поля status в строке бэка (ветвление по status строки).
      this.drafts = (payload.data as DraftListRow[]).map((item) => ({
        ...item,
        status: PretensionStatus.DRAFT,
        typeName: this.deriveTypeName(item.type),
        // Автор для колонки — email владельца (однозначный идентификатор); иначе прочерк.
        authorDisplay: item.created_by_email || '—',
      }));
    }
    this.draftsLoading = false;
  }

  openDraft(row: { id: number }): void {
    const ref = this.$refs.createPretension as any;
    if (ref && typeof ref.openForEdit === 'function') {
      // openForEdit сам тянет getDraft(id) за свежим updatedAt/draftPayload.
      ref.openForEdit(row.id);
    }
  }

  get suppliersFilterVisible(): boolean {
    return !this.isSupplier;
  }

  get visibleTables(): TableData[] {
    if (!this.isSupplier) return this.tables;
    // string[], не PretensionStatus[] — TableData.status имеет тип string
    // (см. types/DraggableDataTableTypes.ts:4), TS strict не пропустит
    // Array<PretensionStatus>.includes(string). Enum-values implicitly extend string —
    // присвоение enum в string[] безопасно.
    // БЦ3.3 followup FML-wccv.9: SUPPLIER не видит ACCOUNTING_APPROVE_AWAIT (внутренний
    // FML accounting шаг). Целевой флоу (§8): payment_await ретайрнут (ожидание оплаты =
    // accounting_approve_await + sent_to_erp_at, внутренний этап, скрыт от SUPPLIER).
    const allowed: string[] = [
      PretensionStatus.SUPPLIER_SIGNING_AWAIT,
      PretensionStatus.PAYMENT_DONE,
      PretensionStatus.RECALLED,
    ];
    return this.tables.filter((t) => allowed.includes(t.status));
  }

  get displayedHeaders(): Array<{ text: string; value: string }> {
    if (!this.isSupplier) return this.headers;
    // БЦ3.3 followup Issue 1.2: SUPPLIER не видит internal FML колонки:
    //   - supplier_legal_name: supplier знает себя
    //   - platform_name: internal FML categorization
    const hidden: string[] = ['supplier_legal_name', 'platform_name'];
    return this.headers.filter((h) => !hidden.includes(h.value));
  }

  async beforeMount() {
    // Misconfiguration check РАНЬШЕ любых API-вызовов: SUPPLIER без supplier_id
    // редиректится моментально, без перехода в Apollo/PimCore (где backend в enforce
    // mode мог бы вернуть 403 и сломать flow). Также loadingPage=false до redirect —
    // иначе при асинхронном route-switch остался бы вечный spinner.
    if (this.isSupplier && !this.pimcoreUser?.supplier_id) {
      console.error('SUPPLIER user without supplier_id — misconfiguration');
      this.loadingPage = false;
      this.$router.replace({ name: 'AccessDenied' });
      return;
    }

    this.loadingPage = true;
    this.calculateDefaultDates();
    this.platformsList = await this.loadEntityListing('PlantsHR', undefined, 'network-only', { maxDepth: 1 });
    this.selectedPlatforms = this.getFromStorage('platform')
      .split(',')
      .filter((platformId) => platformId.trim() !== '');

    if (this.isSupplier) {
      // Auto-filter: SUPPLIER видит только свои претензии. selectedSuppliers НЕ читается
      // из localStorage и НЕ дозволяет user-override. loadSuppliers() пропускается —
      // backend в Phase 2 вернёт 403 на listing Supplier'ов под токеном SUPPLIER (FR-FE-004).
      this.selectedSuppliers = [String(this.pimcoreUser!.supplier_id)];
      this.suppliersList = [];
    } else {
      this.suppliersList = await this.loadSuppliers();
      this.selectedSuppliers = this.getFromStorage('suppliers')
        .split(',')
        .filter((supplierId) => supplierId.trim() !== '');
    }

    await this.reloadTables();
    this.loadingPage = false;
  }

  mounted(): void {
    // Возврат из карточки претензии = ремоунт страницы (нет keep-alive) → beforeMount уже
    // перезагружает данные. Здесь добавляем ФОНОВОЕ автообновление каждую минуту.
    this.schedulePolling();
    this.openCreateFormFromQuery();
  }

  // «Создать претензию» из карточки листа приходит с параметрами формы (задача 10833). С адреса
  // снимаем их последним шагом: фильтр «Дата создания претензии» при монтировании дописывает в адрес
  // свои dateFrom/dateTo вместе с тем, что там было, и более ранняя чистка вернулась бы обратно.
  // Без чистки обновление страницы открыло бы и заполнило форму повторно.
  private async openCreateFormFromQuery(): Promise<void> {
    const prefill = pretensionPrefillFromQuery(this.$route.query);
    if (!prefill) return;
    const form = this.$refs.createPretension as unknown as { openWithPrefill(p: PretensionPrefill): Promise<void> } | undefined;
    try {
      if (this.isHR && form) await form.openWithPrefill(prefill);
    } finally {
      await this.$nextTick();
      await this.$router.replace({ query: queryWithoutPrefill(this.$route.query) }).catch(() => undefined);
    }
  }

  beforeDestroy(): void {
    this.stopPolling();
  }

  private schedulePolling(): void {
    this.stopPolling();
    this.pollingTimer = window.setInterval(() => {
      // Пауза при скрытой вкладке и во время ручной/первичной загрузки — не накладываемся.
      if (document.hidden || this.loadingPage) return;
      this.reloadTablesSilent();
    }, Pretensions.POLLING_INTERVAL_MS);
  }

  private stopPolling(): void {
    if (this.pollingTimer !== null) {
      window.clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  // Тихая перезагрузка для фонового polling: без спиннеров (loadingPage/table.loading)
  // и без error-тостов — чтобы фон раз в минуту не мигал и не спамил ошибками.
  // Re-entrancy guard: silent-перезагрузка не выставляет loadingPage, поэтому защищаемся
  // отдельным флагом — если предыдущий тик ещё грузит (медленный бэк), новый пропускаем.
  private async reloadTablesSilent(): Promise<void> {
    if (this.isSilentReloading) return;
    this.isSilentReloading = true;
    try {
      await Promise.all(this.visibleTables.map((t) => this.reloadTable(t, true)));
    } finally {
      this.isSilentReloading = false;
    }
  }

  calculateDefaultDates() {
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.defaultDates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  async reloadTables() {
    this.loadingPage = true;
    // Используем visibleTables (а не this.tables): для SUPPLIER pre-EDO статусы
    // (CREATED/CONTROL_AWAIT/SIGNER_SIGNING_AWAIT/PROBLEM) НЕ рендерятся —
    // нет смысла грузить их с backend'а. Экономим RTT и backend ACL-load
    // amplifier для каждого SUPPLIER login. Для не-SUPPLIER ролей visibleTables === tables —
    // поведение не меняется. reloadTable() ищет по table.status через findIndex в this.tables,
    // так что мутации индекса остаются корректными.
    const promises: Array<Promise<any>> = [];
    const tablesToReload = this.visibleTables;
    for (let i = 0; i < tablesToReload.length; i += 1) {
      promises.push(this.reloadTable(tablesToReload[i]));
    }
    await Promise.all(promises);
    await this.loadDrafts();
    this.loadingPage = false;
  }

  async reloadTable(table: TableData, silent = false) {
    const currentIndex = this.tables.findIndex((v: TableData) => v.status === table.status);
    if (!silent) this.tables[currentIndex].loading = true;
    const currentTable = this.tables[currentIndex];
    currentTable.pagination = table.pagination || this.defaultPagination;
    const { data, total } = await this.loadPretensions(currentTable.pagination, currentTable.status, silent);
    currentTable.items = this.handleData(data);
    currentTable.pagination.itemsLength = total;
    currentTable.pagination.pageCount = Math.ceil(total / currentTable.pagination.itemsPerPage);
    currentTable.loading = false;
    this.$set(this.tables, currentIndex, currentTable);
  }

  async loadPretensions(pagination: DataPagination, status: string, silent = false): Promise<{ data: Array<Pretension>; total: number }> {
    const { page, itemsPerPage } = pagination;
    const resp = await PretensionController.list({
      pageFrom: (page - 1) * itemsPerPage,
      pageSize: itemsPerPage,
      status,
      createdAt: this.dates,
      // Несколько платформ уходят одной строкой «12,34»: Talend передаёт platformId
      // прозрачно, список разбирает PHP (Search::expandPlatformIdList).
      platformId: this.selectedPlatforms.join(','),
      suppliers: this.selectedSuppliers,
      type: this.selectedType,
    });
    if (resp.result[0]) {
      if (!silent) this.$bus.$emit('notification', `${resp.result[0]}`, 'error');
      return { data: [], total: 0 };
    }
    return resp.result[1];
  }

  async loadSuppliers() {
    if (!this.selectedPlatforms.length) {
      return this.loadEntityListing('Supplier', undefined, 'network-only', { maxDepth: 1 });
    }
    // Поставщики по объединению выбранных платформ — как в списке листов учёта.
    const filters = this.selectedPlatforms.map((platformId) => like('PlantsHR', `%${platformId}%`));
    const filter = (new FilterBuilder())
      .addFilters(filters.length === 1 ? and(filters[0]) : or(...filters))
      .build();
    return this.loadEntityListing('Supplier', { filter }, 'network-only', { maxDepth: 1 });
  }

  // Заголовок «Тип» из кода типа ($t(type)); прочерк, если тип не задан. Общий для строк
  // статусов (handleData) и черновиков (loadDrafts) — единый источник правды по колонке.
  private deriveTypeName(type: string | null | undefined): string {
    return type ? String(this.$t(type)) : '—';
  }

  handleData(data: Pretension[]): Pretension[] {
    const copy = data.map((item) => {
      const clonedObj = { ...item, typeName: this.deriveTypeName(item.type) };
      return clonedObj;
    });
    return copy;
  }

  changeDates(dates: Array<string>) {
    this.dates = dates;
  }

  changeSuppliers(suppliers: Array<any>) {
    this.selectedSuppliers = suppliers;
    this.setToStorage('suppliers', suppliers.join(','));
  }

  async changePlatforms(platforms: Array<string> | null) {
    this.selectedPlatforms = (platforms || []).map((platformId) => String(platformId));
    this.setToStorage('platform', this.selectedPlatforms.join(','));
    if (this.isSupplier) return; // auto-filter сохраняется; loadSuppliers не вызывается
    this.selectedSuppliers = [];
    this.setToStorage('suppliers', '');
    this.suppliersList = await this.loadSuppliers();
  }

  /** Все платформы уже выбраны — кнопке нечего делать. */
  get canSelectAllPlatforms(): boolean {
    return !this.loadingPage
      && this.platformsList.length > 0
      && this.selectedPlatforms.length !== this.platformsList.length;
  }

  selectAllPlatforms() {
    if (!this.canSelectAllPlatforms) {
      return;
    }
    this.changePlatforms(this.platformsList.map((platform) => String(platform.id)));
  }

  get canSelectAllSuppliers(): boolean {
    return !this.loadingPage
      && this.suppliersList.length > 0
      && this.selectedSuppliers.length !== this.suppliersList.length;
  }

  selectAllSuppliers() {
    if (!this.canSelectAllSuppliers) {
      return;
    }
    this.changeSuppliers(this.suppliersList.map((supplier) => supplier.id));
  }

  changeType(type: string) {
    this.selectedType = type;
    this.setToStorage('type', type);
  }

  dragChange(event: any, table: any) {
    // await this.reloadTable(table);
    // send request to move item to next status
    // on successful status change or fail - reload both tables
    console.log('change', event, table);
  }

  move(item: any, to: any) {
    console.log('move', item, to);
  }

  clickRow(event: any) {
    if (!event?.id) return;
    // Строка-черновик → форма редактирования (гидрация из draft_payload); прочие статусы →
    // карточка претензии. Один обработчик на оба блока (статусы и черновики).
    if (event.status === PretensionStatus.DRAFT) {
      this.openDraft(event);
      return;
    }
    this.$router.push({ name: 'PretensionPage', params: { id: event.id } });
  }

  async onPagination(pagination: DataPagination, table: TableData) {
    if (pagination.itemsPerPage === table?.pagination?.itemsPerPage && pagination.pageStart === table?.pagination?.pageStart) {
      return;
    }
    table.loading = true;
    table.pagination = pagination;
    await this.reloadTable(table);
    table.loading = false;
  }

  filtersChanged(): boolean {
    // S1 fix (rev.7): для SUPPLIER auto-filter в selectedSuppliers всегда установлен,
    // но это не пользовательское «изменение» — не показывать кнопку «Очистить фильтры»
    // на основании этого. Кнопка появляется только при реальных user-changes (тип/платформа/даты).
    const suppliersChanged = !this.isSupplier && this.selectedSuppliers.length > 0;
    return suppliersChanged
      || this.selectedType !== ''
      || this.selectedPlatforms.length > 0
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  clearFilters() {
    this.changeType('');
    this.changePlatforms([]);
    // Emit broadcast 'clear-filters' — DateRange его слушает чтобы сбросить даты
    // ([DateRange.vue:101](src/components/common/DateRange.vue#L101)). selectedSuppliers
    // явно не сбрасывается этой функцией ни для одной роли — для SUPPLIER инвариант
    // auto-filter сохраняется автоматически (Q-FE5).
    this.$bus.$emit('clear-filters');
  }

  humanize(code: string): string {
    return humanizePretensionStatus(
      code,
      (k: string) => this.$t(k) as string,
      this.isSupplier ? 'supplier' : undefined,
    );
  }
}
